/**
 * Bridge used when the dashboard runs inside a host page (Traffix) as an iframe.
 *
 * Outgoing (dashboard → host):
 *   mystery-client:ready            → the dashboard finished booting
 *   mystery-client:sidebar {open}   → drill-down sidebar opened/closed
 *
 * Incoming (host → dashboard), handled in App/MapDashboard:
 *   mystery-client:show / :reset    → back to the default view (all cities)
 *   mystery-client:request-state    → re-send the current sidebar state
 *   mystery-client:invalidate/:resize → recompute the map size
 */
export const EMBED_MESSAGE_SOURCE = 'mystery-client';

export const isEmbedded = () => {
  try {
    return typeof window !== 'undefined' && window.parent && window.parent !== window;
  } catch {
    return false;
  }
};

/**
 * Send a notification to the host frame. Only UI state is shared, never
 * credentials, so any host origin is allowed to receive it.
 */
export const notifyHost = (type, payload = {}) => {
  if (!isEmbedded()) return;
  try {
    window.parent.postMessage({ source: EMBED_MESSAGE_SOURCE, type, ...payload }, '*');
  } catch {
    // Host frame may be cross-origin restricted; ignore.
  }
};
